import { createFileRoute } from "@tanstack/react-router";
import { apiQuery, useApiSuspenseQuery } from "@/client/lib/api";
import { ensurePage, pageHead } from "@/client/lib/page";
import { AtestadoPrintClient } from "@/client/modules/atendimento/atestado/detalhe/atestado-print-client";

export const Route = createFileRoute("/app/atendimento/atestado/$id")({
  loader: ({ context, params }) =>
    ensurePage(context.queryClient, apiQuery("atendimento", "atestadoPage", { id: params.id })),
  head: () => pageHead("Atestado"),
  component: PrintPage,
});

function PrintPage() {
  const { id } = Route.useParams();
  const { data } = useApiSuspenseQuery("atendimento", "atestadoPage", { id });
  return <AtestadoPrintClient certificate={data} />;
}
